import { render, staticRenderFns } from "./uploadFbpClaim.vue?vue&type=template&id=b653c52c&scoped=true&lang=html"
import script from "./uploadFbpClaim.vue?vue&type=script&lang=js"
export * from "./uploadFbpClaim.vue?vue&type=script&lang=js"
import style0 from "./uploadFbpClaim.vue?vue&type=style&index=0&id=b653c52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b653c52c",
  null
  
)

export default component.exports